<template>
  <div v-frag class="fadeIn">
    <CardIeaAppMain>
      <v-container fluid class="pa-4">
        <!-- HEADER -->
        <v-row align="center" class="mb-6">
          <v-col cols="12">
            <h1 class="text-h4 font-weight-bold bce-text-gradient">Mis Pagos y Estructura</h1>
            <p class="grey--text text--darken-1">Consulta tu historial administrativo, pagos realizados y la estructura de aranceles de tu carrera.</p>
          </v-col>
        </v-row>

        <div v-if="loading" class="text-center pa-10">
          <v-progress-circular indeterminate color="#E50050" size="48"></v-progress-circular>
          <div class="mt-4 grey--text">Cargando información administrativa...</div>
        </div>

        <div v-else>
          <div v-if="data && data.length > 0">
            <v-row>
              <v-col v-for="(itemTable, keyTable) in data" :key="keyTable" cols="12">
                <v-card class="rounded-xl elevation-3 overflow-hidden mb-6 bce-payment-card">
                  <div class="bce-payment-header pa-4 white--text d-flex align-center">
                    <v-avatar color="rgba(255,255,255,0.2)" size="32" class="mr-3">
                      <v-icon color="white" small>mdi-cash</v-icon>
                    </v-avatar>
                    <span class="text-h6 font-weight-bold">{{ itemTable.nombre }}</span>
                  </div>

                  <v-card-text class="pa-0">
                    <v-simple-table class="bce-premium-table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left font-weight-bold grey--text text--darken-2">Concepto</th>
                            <th class="text-right font-weight-bold grey--text text--darken-2" style="width: 200px;">Importe</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemTableData, keyItemTableData) in itemTable.data" :key="keyItemTableData" class="bce-tr-hover">
                            <td class="font-weight-medium py-4">{{ itemTableData.Concepto }}</td>
                            <td class="text-right py-4">
                              <span class="text-h6 font-weight-black bce-red-text">${{ itemTableData.Monto }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <!-- EMPTY STATE -->
          <v-alert
            v-else
            border="left"
            colored-border
            color="grey darken-1"
            elevation="2"
            class="rounded-xl mt-4"
          >
            No se encontraron registros de pagos o estructuras arancelarias asociadas a tu cuenta.
          </v-alert>
        </div>
      </v-container>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain.vue";

export default {
  name: "MisPagos",
  components: { CardIeaAppMain },
  data: () => ({ 
    data: [], 
    loading: true 
  }),
  mounted() { 
    this.tuPagos(); 
  },
  methods: {
    async tuPagos() {
      this.loading = true;
      try {
        const res = await this.$API.get({ url: "alumno/pagos", data: {} });
        this.data = res || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.bce-text-gradient {
  background: linear-gradient(45deg, #1a237e 30%, #E50050 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bce-red-text {
  color: #E50050;
}

.bce-payment-card {
  transition: all 0.3s;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.bce-payment-header {
  background: linear-gradient(135deg, #2c3e50 0%, #1a237e 100%);
}

.bce-premium-table thead th {
  background-color: #f8f9fa !important;
  height: 50px !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.5px;
}

.bce-tr-hover:hover {
  background-color: #fffafa;
}

.fadeIn { 
  animation: fadeIn 0.4s ease-in-out; 
}

@keyframes fadeIn { 
  from { opacity: 0; transform: translateY(10px); } 
  to { opacity: 1; transform: translateY(0); } 
}
</style>
